// Modules
import { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";
import html2canvas from "html2canvas";
import { Toaster, toast } from "react-hot-toast";
import jwt_decode from "jwt-decode";
// Context
import { ReadingTimeContext } from "../../../Context/readingTimeContext";
import { AuthContext } from "../../../Context/AuthContext";
// API
import { QuarterlyPageImagesContext } from "../../../Context/quarterlyPagesContext";
import {
  getSingleQuarterly,
  getSingleQuarterlyNotBuyed,
} from "../../../Services/getData";
import {
  createComment,
  setLastPageUserReaded,
  setReadingTime,
} from "../../../Services/usersService";
// Components
import PageCover from "../../Common/Library/PageCover/PageCover";
import Pages from "../../Common/Library/Pages/Pages";
import Comment from "../../Common/Comment/Comment";
import RemainingTime from "../../Common/readingTime/RemainingTime";
import ReadingTime from "../../Common/readingTime/ReadingTime";
// Images
import logoImg from "../../../Assets/Images/logo.png";
import closeImg from "../../../Assets/Icons/close.png";
// Styles
import Styles from "./Styles/QuarterlyLibrary.module.css";
// Utils
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";
import QuarterlyPages from "../../Common/QuarterlyPages/QuarterlyPages";

const QuarterlyLibrary = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const { removeImages } = useContext(QuarterlyPageImagesContext);
  const history = useHistory();
  const { quarterlyId } = useParams();
  const [showQuarterlyDescription, setShowQuarterlyDescription] =
    useState(true);
  const [flipPageWidth, setFlipPageWidth] = useState(500);
  const [flipPageHeight, setFlipPageHeight] = useState(600);
  const pageFlipRef = useRef(null);
  const [showComments, setShowComments] = useState(false);
  const [quarterlyPages, setQuarterlyPages] = useState([]);
  const [quarterly, setQuarterly] = useState();
  const [purchased, setPurchased] = useState(false);
  // const textDownloadRef = useRef();

  const [percentage, setPercentage] = useState(0);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [startPage, setStartPage] = useState(0);

  const token = localStorage.getItem("token");
  const [decodedToken, setDecodedToken] = useState();

  const [commentSendTimer, setCommentSendTimer] = useState(0);
  const [commentText, setCommentText] = useState("");
  const [commentSended, setCommentSended] = useState(false);

  const [haveEmptyPage, setHaveEmptyPage] = useState(false);

  useEffect(() => {
    removeImages();
  }, []);

  // محدودیت ارسال کامنت
  useEffect(() => {
    if (commentSendTimer !== 0) {
      const sendCommentTimerInterval = setInterval(() => {
        setCommentSendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(sendCommentTimerInterval);
    }
  }, [commentSendTimer]);

  useEffect(() => {
    if (token) {
      setDecodedToken(jwt_decode(token));
    }
  }, [token]);
  // create view
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       await createView({ type: "book", id: bookId });
  //     } catch (ex) {
  //       toast.error(ex.response.data.message);
  //     }
  //   };
  //   // if(isLoggedIn&&book.)
  //   fetchData();
  // }, []);

  // ارسال زمان مطالعه هنگام خروج
  const { timer, addTime, resetTimer } = useContext(ReadingTimeContext);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      addTime();
    }, 1000);
    return () => clearInterval(timerInterval);
  }, [timer, addTime]);

  useEffect(() => {
    const fetchData = async () => {
      const data = { kind: "quarterly", id: quarterly._id, readingTime: timer };
      try {
        await setReadingTime(data);
        resetTimer();
      } catch (ex) {
        console.log(ex.response.data.message);
      }
    };
    if (timer / 60 === 1) {
      fetchData();
    }
  }, [timer, quarterly, resetTimer]);

  // دریافت اطلاعات
  useEffect(() => {
    const api = async () => {
      try {
        let data;
        if (isLoggedIn) {
          const result = await getSingleQuarterly(quarterlyId);
          data = result.data;
        } else {
          const result = await getSingleQuarterlyNotBuyed(quarterlyId);
          data = result.data;
          toast.error(
            "جهت مطالعه خلاصه فصلنامه لطفا وارد حساب کاربری خود شوید"
          );
        }
        const newQuarterlypages = data.quarterlyPagesAddress;
        if (data.quarterlyPagesAddress.length % 2 === 1) {
          setHaveEmptyPage(true);
        }
        // setBookPages(data.bookPagesAddress);
        setQuarterlyPages(newQuarterlypages);
        setPurchased(data.purchase);
        setQuarterly(data.quarterly);

        setStartPage(
          data.startPage === data.quarterlyPagesAddress.length
            ? data.quarterlyPagesAddress.length - 1
            : data.startPage
        );
        setPercentage(
          data.startPage === data.quarterlyPagesAddress.length
            ? Math.round(
                ((data.startPage - 1) * 100) / data.quarterlyPagesAddress.length
              )
            : Math.round(
                (data.startPage * 100) / data.quarterlyPagesAddress.length
              )
        );
        setCurrentPage(data.quarterlyPagesAddress.length - data.startPage);
        setTotalPages(data.quarterlyPagesAddress.length + 1);
      } catch (ex) {
        toast.error(ex.response.data.message);
      }
    };
    api();
  }, [quarterlyId, history, commentSended, isLoggedIn, token]);

  //* quarterly size handler
  useEffect(() => {
    if (window.innerWidth < 400) {
      setFlipPageWidth(350);
      setFlipPageHeight(450);
    } else if (window.innerWidth < 500) {
      setFlipPageWidth(400);
      setFlipPageHeight(500);
    }
  }, []);

  //* flip quarterly with keyboard
  const flipPageForward = async () => {
    if (pageFlipRef.current) {
      pageFlipRef.current.pageFlip().flipNext();
    }
  };

  const flipPageBackward = () => {
    if (pageFlipRef.current) {
      pageFlipRef.current.pageFlip().flipPrev();
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.keyCode === 37) {
        // دکمه چپ کیبورد
        flipPageBackward();
      } else if (event.keyCode === 39) {
        // دکمه راست کیبورد
        flipPageForward();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  //* download page handler
  const downloadImage = (downloadRef) => {
    html2canvas(downloadRef.current).then((canvas) => {
      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "card.png";
      link.click();
    });
  };

  function convertSpecificNumbersToPersian(text) {
    const persianNumbers = {
      0: "۰",
      1: "۱",
      2: "۲",
      3: "۳",
      4: "۴",
      5: "۵",
      6: "۶",
      7: "۷",
      8: "۸",
      9: "۹",
    };

    return text.replace(/[0-9]/g, function (match) {
      return persianNumbers[match];
    });
  }
  // sendComment
  const sendComment = (comment) => {
    if (!isLoggedIn) {
      toast.error("برای نظردهی ابتدا باید وارد حساب کاربری خود شوید");
      return;
    }
    if (comment.length === 0) {
      toast.error("لطفا ابتدا یک متن وارد کنید");
      return;
    }
    if (commentSendTimer === 0) {
      const data = {
        comment,
        userId: decodedToken.user.userId,
        id: quarterly._id,
        kind: "quarterly",
      };
      toast.promise(createComment(data), {
        loading: "درحال ارسال نظر شما . . .",
        success: (res) => {
          setCommentSended((prev) => !prev);
          setCommentText("");
          setCommentSendTimer(60);
          return res.data.message;
        },
        error: (res) => res.data.message,
      });
    } else {
      toast.error(
        `لطفا ${convertSpecificNumbersToPersian(
          commentSendTimer.toString()
        )} ثانیه بعد کامنت بعدی خود را ارسال کنید`
      );
    }
  };

  return (
    <div className={Styles.mainConatiner}>
      <Toaster toastOptions={{ duration: 1500 }} />
      <ReadingTime Styles={Styles} />

      {showComments && (
        <div className={Styles.commentsContainer}>
          <div
            className={Styles.hideComments}
            onClick={() => setShowComments(false)}
          >
            <img src={closeImg} alt="" />
          </div>
          {quarterly !== undefined && quarterly.comments?.length > 0 ? (
            quarterly.comments.map((item, index) => (
              <Comment
                comment={item.comment}
                username={item.username}
                key={index}
              />
            ))
          ) : (
            <h2 style={{ marginBottom: "25px", color: "#4b495b" }}>
              دیدگاهی وجود ندارد
            </h2>
          )}
          <div className={Styles.sendComment}>
            <div className={Styles.textContainer}>
              <textarea
                placeholder="دیدگاه خود را اینجا بنویسید . . ."
                name="comment"
                id="comment"
                cols="30"
                rows="10"
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              ></textarea>
              <div className={Styles.title}>
                <h3>دیدگاه</h3>
                <h3>شما</h3>
              </div>
            </div>
            <div className={Styles.sendContainer}>
              <div
                className={Styles.send}
                style={{ textAlign: "center", width: "85.5%" }}
                onClick={() => sendComment(commentText)}
              >
                ثبت
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={Styles.header}>
        <div className={Styles.logoContainer}>
          <div className={Styles.logo}>
            <img src={logoImg} alt="" />
          </div>
        </div>
        <div className={Styles.optionsContainer}>
          <div className={Styles.options}>
            <Link to="/">صفحه اصلی</Link>
            <div className={Styles.separator}></div>
            <h4 onClick={() => setShowComments(true)}>نظر ها</h4>
            <div className={Styles.separator}></div>
            <RemainingTime Styles={Styles} />
          </div>
          <div className={Styles.percent}>
            {purchased ? (
              <h4>
                میزان پیشروی : %{convertNumbersToPersian(percentage.toString())}
              </h4>
            ) : (
              <h4>میزان پیشروی : ۰٪</h4>
            )}
          </div>
        </div>
      </div>

      <div
        className={Styles.bookShortDescription}
        style={showQuarterlyDescription ? {} : { display: "none" }}
      >
        <div className={Styles.right}>
          <div className={Styles.bookShortDescriptionTitleContainer}>
            <h1>چکیده ای از فصلنامه</h1>
          </div>
          <p>{quarterly?.shortDesc}</p>
          {isLoggedIn && (
            <button onClick={() => setShowQuarterlyDescription(false)}>
              خواندن فصلنامه
            </button>
          )}
        </div>
        <div className={Styles.left}></div>
      </div>
      {quarterly !== undefined &&
        (haveEmptyPage ? (
          <HTMLFlipBook
            showPageCorners={false}
            showCover={true}
            className={Styles.bookContainer}
            width={flipPageWidth}
            height={flipPageHeight}
            ref={pageFlipRef}
            mobileScrollSupport={true}
            startPage={totalPages - startPage + 1}
            onFlip={async (e) => {
              setPercentage(
                e.data === 0
                  ? 100
                  : e.data > totalPages
                  ? 0
                  : Math.round(
                      ((quarterlyPages.length - e.data) * 100) / totalPages
                    )
              );
              if (e.data - 1 === totalPages) {
                setShowQuarterlyDescription(true);
              }
              setCurrentPage(e.data);
              if (purchased) {
                try {
                  const data = {
                    pageNumber: quarterlyPages.length - e.data,
                    quarterlyId: quarterly._id,
                  };
                  await setLastPageUserReaded(data);
                } catch (ex) {
                  console.log(ex);
                }
              }
            }}
          >
            <PageCover
              purchase={purchased}
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${quarterly.backCover}`}
              position="back"
              bookId={quarterlyId}
              price={quarterly.price}
              title={quarterly.title}
              quarterly={true}
            />
            <div className={Styles.emptyPage}></div>
            {quarterlyPages.map((page, index) => (
              <QuarterlyPages
                currentPage={
                  currentPage === 0
                    ? currentPage
                    : quarterlyPages.length - currentPage
                }
                page={page}
                key={index}
                index={index}
                starterPage={startPage}
                pagesLength={quarterlyPages.length}
                pageNumber={quarterlyPages.length - index}
                downloadImage={downloadImage}
                quarterlyName={quarterly.title}
                isLoggedIn={isLoggedIn}
              />
            ))}

            <PageCover
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${quarterly.frontCover}`}
              position="front"
            />
          </HTMLFlipBook>
        ) : (
          <HTMLFlipBook
            showPageCorners={false}
            showCover={true}
            className={Styles.bookContainer}
            width={flipPageWidth}
            height={flipPageHeight}
            ref={pageFlipRef}
            mobileScrollSupport={true}
            startPage={totalPages - startPage}
            onFlip={async (e) => {
              setPercentage(
                e.data === 0
                  ? 100
                  : e.data > totalPages
                  ? 0
                  : Math.round(
                      ((quarterlyPages.length - e.data) * 100) / totalPages
                    )
              );
              if (e.data === totalPages) {
                setShowQuarterlyDescription(true);
              }
              setCurrentPage(e.data);
              if (purchased) {
                try {
                  const data = {
                    pageNumber: quarterlyPages.length - e.data,
                    quarterlyId: quarterly._id,
                  };
                  await setLastPageUserReaded(data);
                } catch (ex) {
                  console.log(ex);
                }
              }
            }}
          >
            <PageCover
              purchase={purchased}
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${quarterly.backCover}`}
              position="back"
              bookId={quarterlyId}
              price={quarterly.price}
              title={quarterly.title}
              quarterly={true}
            />

            {quarterlyPages.map((page, index) => (
              <QuarterlyPages
                currentPage={
                  currentPage === 0
                    ? currentPage
                    : quarterlyPages.length - currentPage
                }
                page={page}
                key={index}
                index={index}
                starterPage={startPage}
                pagesLength={quarterlyPages.length}
                pageNumber={quarterlyPages.length - index}
                downloadImage={downloadImage}
                quarterlyName={quarterly.title}
                isLoggedIn={isLoggedIn}
              />
            ))}

            <PageCover
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${quarterly.frontCover}`}
              position="front"
            />
          </HTMLFlipBook>
        ))}
    </div>
  );
};

export default QuarterlyLibrary;
